<template>
  <div class="fiche-suivi">

    <description-sollicitation :show-photo="false" :sollicitation="sollicitation"></description-sollicitation>

    <liste-suivi-bulle :sollicitation="sollicitation"></liste-suivi-bulle>
    <div>
      <button class="btn btn-primary actionUser d-inline-block mb-2" @click="redirectToCreationSuivi">
        <i class="fas fa-plus"></i> Ajouter un suivi
      </button>
    </div>
    <div v-if = "!sollicitationCloturee && canBill && motifFacturationBadge">
      <button class="btn btn-secondary actionUser d-inline-block mb-2" @click="redirectToFacturationBadge">
        <i class="fas fa-euro-sign"></i> Facturer
      </button>
    </div>
    <div v-if="!sollicitationCloturee && !isGardien && sollicitationChargee">
      <button class="btn btn-danger d-inline-block mb-2" @click="redirectToCloture"><i
          class="fas fa-times "></i> Clôturer
      </button>
    </div>
    <hr>

    <b-overlay :show="showOverlay">
      <div class="row justify-content-center mx-0">
        <div class="col-12">
          <input id="myFileInput" ref="myFileInput" accept="image/*" capture style="display: none;" type="file"
                 @change="uploadImage"/>
          <button class="btn btn-primary mb-3" onclick="document.getElementById('myFileInput').click();">
            <i class="fas fa-camera"></i>
          </button>
        </div>

        <div class="col-12">
          <b-carousel
              id="carousel"
              :interval=null
              background="#ababab"
              controls
              indicators
              style="text-shadow: 1px 1px 2px #333;"
          >
            <b-carousel-slide v-for="item in pictures" :key="item.nomFichier" style="height: 450px !important;">
              <template #img>
                <div class="d-flex h-100 align-items-center justify-content-center">
                  <a :href='"data:" + item.mimeType + ";base64," + item.blob' download="file" class="align-middle my-auto">
                    <img :id='item.nomFichier'
                         :src='"data:" + item.mimeType + ";base64," + item.blob'
                         class="carousel-img"
                         v-if="item.mimeType.includes('image')"
                    />
                    <i v-else-if="item.mimeType.includes('pdf')"  class="fas fa-file-pdf fa-10x align-middle my-auto"></i>
                    <i v-else class="fas fa-file fa-10x align-middle"></i>
                  </a>
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import DescriptionSollicitation from "./DescriptionSollicitation";
import ListeSuiviBulle from "../ListeSuiviBulle";
import toast from "@/js/toast";

export const resizeImage = function (settings) {
  var file = settings.file;
  var maxSize = settings.maxSize;
  var reader = new FileReader();
  var image = new Image();
  var canvas = document.createElement('canvas');

  var resize = function () {
    var width = image.width;
    var height = image.height;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
    return canvas.toDataURL('image/jpeg');
  };
  return new Promise(function (ok, no) {
    if (!file.type.match(/image.*/)) {
      no(new Error("Not an image"));
      alert("Le fichier n'est pas pris en charge, veuillez mettre une image");
      this.showOverlay = false
      return;
    }
    reader.onload = function (readerEvent) {
      image.onload = function () {
        return ok(resize());
      };
      image.src = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export default {
  name: "FicheSuivi",
  components: {DescriptionSollicitation, ListeSuiviBulle},
  data() {
    return {
      sollicitationID: this.$route.params.id,
      sollicitation: new Object(
          {
            id: "Chargement en cours",
            entree: "Chargement en cours",
            libelleProg: "Chargement en cours",
            libelleAdresse: "Chargement en cours",
            libelleModule: "Chargement en cours"
          }
      ),
      pictures: null,
      fileName: "Choisir une image...",
      showOverlay: true,
    }
  },
  methods: {
    updateFileName(event) {
      let fileData = event.target.files[0];
      this.fileName = fileData.name;
    },
    async uploadImage() {
      let file = document.querySelector('#myFileInput').files[0];
      if (file) {
        let extension = file.name.slice(file.name.lastIndexOf('.'))
        this.showOverlay = true
        const config = {
          file: file,
          maxSize: 1000
        };

        let picture = await resizeImage(config)
        let resizedImage = picture.split(',')[1]

        let success = await this.$store.dispatch('pictures/uploadPicture', {
          image: resizedImage, 
          sollicitation: this.sollicitationID, 
          mimeType: file.type, 
          extension
        })

        if (success) {
          toast.showToast('success', 'La photo a bien été enregistrée')
          this.$refs["myFileInput"].value = "";
          this.fileName = "Choisir une image..."
          this.pictures = await this.$store.dispatch('pictures/getPicturesOfSollicitation', this.sollicitationID)
          this.showOverlay = false
        } else {
          toast.showToast('error', 'Echec de l\'envoi essayez à nouveau')
          this.showOverlay = false
        }
      } else {
        alert('Veuillez choisir une photo')
      }
    },
    redirectToCreationSuivi() {
      this.$router.push({name: 'evenements'});
    },
    redirectToFacturationBadge() {
      this.$router.push({name: 'facturerbadge', query: { contrat: this.sollicitation.reclamant, sollicitation: this.sollicitation.id } });
    },
    redirectToNouvelleLigne() {
      this.$router.push({
        name: 'categories',
        params: {sollicitation: this.sollicitationID}
      });
    },
    redirectToCloture(){
      this.$router.push({name: 'MotifsCloture'});
    }
  },
  computed:{
    sollicitationEtat(){
          return this.sollicitation.etat
    },
    sollicitationCloturee(){
      return (this.sollicitationEtat == 'C' || this.sollicitationEtat == 'R'); // C=cloturé, R=Rejeté
    },
    isGardien() {
      // evaluate whatever you need to determine disabled here...
      return this.$store.getters['user/isGardien'];    
    },
    sollicitationChargee(){
      return !(this.sollicitation.id == "Chargement en cours");
    },
    motifFacturationBadge(){
      return process.env.VUE_APP_MOTIF_FACTURATION_BADGE.split(",").includes(this.sollicitation.motif);
    },
    canBill(){
      return this.$store.getters['user/canBillBadge'];
    }
  },    
  async mounted() {
    this.$store.dispatch('title/setTitle', 'Sollicitation');
    // Chargement des suivis
    this.$store.dispatch('suivis/clearSuivis')
    this.$store.dispatch('suivis/loadSuivisFromAPI', this.sollicitationID)

    // Chargement de la sollicitation depuis l'URL
    this.sollicitation = await this.$store.dispatch('sollicitations/loadSingleSollicitation', this.sollicitationID)
    this.$store.dispatch('sollicitations/setSelectedSollicitation', this.sollicitation.id)

    this.pictures = await this.$store.dispatch('pictures/getPicturesOfSollicitation', this.sollicitationID);
    this.showOverlay = false
  }

}
</script>

<style scoped>
* {
  --bubble-background-right: rgba(139, 136, 159, 0.2);
  --bubble-background-left: rgba(139, 136, 159, 0.5);
}

.fiche-suivi {
  padding-bottom: 20px;
}

.actionUser {
  font-size: 18px;
  padding: 10px;
}

.carousel-img {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
